interface ICountry {
  code: number;
  sv: string;
  start?: boolean;
  iso2?: string;
}

// https://gs1.se/guider/dokumentation/kodlistor/t3784-landskod/
// http://www.gs1.se/services/codelist/3.1/T3784.xml
const countries: ICountry[] = [
  { code: 1, sv: 'Global marknad', start: true },
  { code: 4, sv: 'Afghanistan', iso2: 'af' },
  { code: 8, sv: 'Albanien', iso2: 'al' },
  { code: 10, sv: 'Antarktis', iso2: 'aq' },
  { code: 12, sv: 'Algeriet', iso2: 'dz' },
  { code: 16, sv: 'Amerikanska Samoa', iso2: 'as' },
  { code: 20, sv: 'Andorra', iso2: 'ad' },
  { code: 24, sv: 'Angola', iso2: 'ao' },
  { code: 28, sv: 'Antigua och Barbuda', iso2: 'ag' },
  { code: 31, sv: 'Azerbajdzjan', iso2: 'az' },
  { code: 32, sv: 'Argentina', iso2: 'ar' },
  { code: 36, sv: 'Australien', iso2: 'au' },
  { code: 40, sv: 'Österrike', iso2: 'at' },
  { code: 44, sv: 'Bahamas', iso2: 'bs' },
  { code: 48, sv: 'Bahrain', iso2: 'bh' },
  { code: 50, sv: 'Bangladesh', iso2: 'bd' },
  { code: 51, sv: 'Armenien', iso2: 'am' },
  { code: 52, sv: 'Barbados', iso2: 'bb' },
  { code: 56, sv: 'Belgien', iso2: 'be' },
  { code: 60, sv: 'Bermuda', iso2: 'bm' },
  { code: 64, sv: 'Bhutan', iso2: 'bt' },
  { code: 68, sv: 'Bolivia', iso2: 'bo' },
  { code: 70, sv: 'Bosnien och Hercegovina', iso2: 'ba' },
  { code: 72, sv: 'Botswana', iso2: 'bw' },
  { code: 74, sv: 'Bouvetön', iso2: 'bv' },
  { code: 76, sv: 'Brasilien', iso2: 'br' },
  { code: 84, sv: 'Belize', iso2: 'bz' },
  { code: 86, sv: 'Brittiska territoriet i Indiska Oceanen', iso2: 'io' },
  { code: 90, sv: 'Salomonöarna', iso2: 'sb' },
  { code: 92, sv: 'Brittiska Jungfruöarna', iso2: 'vg' },
  { code: 96, sv: 'Brunei', iso2: 'bn' },
  { code: 97, sv: 'Europeiska unionen', iso2: 'eu' },
  { code: 100, sv: 'Bulgarien', iso2: 'bg' },
  { code: 104, sv: 'Burma', iso2: 'mm' },
  { code: 108, sv: 'Burundi', iso2: 'bi' },
  { code: 112, sv: 'Vitryssland', iso2: 'by' },
  { code: 116, sv: 'Kambodja', iso2: 'kh' },
  { code: 120, sv: 'Kamerun', iso2: 'cm' },
  { code: 124, sv: 'Kanada', iso2: 'ca' },
  { code: 132, sv: 'Kap Verde', iso2: 'cv' },
  { code: 136, sv: 'Caymanöarna', iso2: 'ky' },
  { code: 140, sv: 'Centralafrikanska republiken', iso2: 'cf' },
  { code: 144, sv: 'Sri Lanka', iso2: 'lk' },
  { code: 148, sv: 'Tchad', iso2: 'td' },
  { code: 152, sv: 'Chile', iso2: 'cl' },
  { code: 156, sv: 'Kina', iso2: 'cn' },
  { code: 158, sv: 'Taiwan', iso2: 'tw' },
  { code: 162, sv: 'Julön', iso2: 'cx' },
  { code: 166, sv: 'Kokosöarna', iso2: 'cc' },
  { code: 170, sv: 'Colombia', iso2: 'co' },
  { code: 174, sv: 'Komorerna', iso2: 'km' },
  { code: 175, sv: 'Mayotte', iso2: 'yt' },
  { code: 178, sv: 'Kongo-Brazzaville', iso2: 'cg' },
  { code: 184, sv: 'Cooköarna', iso2: 'ck' },
  { code: 180, sv: 'Kongo-Kinshasa', iso2: 'cd' },
  { code: 188, sv: 'Costa Rica', iso2: 'cr' },
  { code: 191, sv: 'Kroatien', iso2: 'hr' },
  { code: 192, sv: 'Kuba', iso2: 'cu' },
  { code: 196, sv: 'Cypern', iso2: 'cy' },
  { code: 203, sv: 'Tjeckien', iso2: 'cz' },
  { code: 204, sv: 'Benin', iso2: 'bj' },
  { code: 208, sv: 'Danmark', iso2: 'dk' },
  { code: 231, sv: 'Etiopien', iso2: 'et' },
  { code: 212, sv: 'Dominica', iso2: 'dm' },
  { code: 214, sv: 'Dominikanska republiken', iso2: 'do' },
  { code: 218, sv: 'Ecuador', iso2: 'ec' },
  { code: 222, sv: 'El Salvador', iso2: 'sv' },
  { code: 226, sv: 'Ekvatorialguinea', iso2: 'gq' },
  { code: 232, sv: 'Eritrea', iso2: 'er' },
  { code: 233, sv: 'Estland', iso2: 'ee' },
  { code: 234, sv: 'Färöarna', iso2: 'fo' },
  { code: 238, sv: 'Falklandsöarna', iso2: 'fk' },
  { code: 239, sv: 'Sydgeorgien och Sydsandwichöarna', iso2: 'gs' },
  { code: 242, sv: 'Fiji', iso2: 'fj' },
  { code: 246, sv: 'Finland', iso2: 'fi' },
  { code: 249, sv: 'France métropolitaine (Frankrike, europeiska delen)', iso2: 'fr' },
  { code: 248, sv: 'Åland', iso2: 'ax' },
  { code: 250, sv: 'Frankrike', iso2: 'fr' },
  { code: 254, sv: 'Franska Guyana', iso2: 'gf' },
  { code: 258, sv: 'Franska Polynesien', iso2: 'pf' },
  { code: 260, sv: 'Franska södra territorierna', iso2: 'tf' },
  { code: 262, sv: 'Djibouti', iso2: 'dj' },
  { code: 266, sv: 'Gabon', iso2: 'ga' },
  { code: 268, sv: 'Georgien', iso2: 'ge' },
  { code: 270, sv: 'Gambia', iso2: 'gm' },
  { code: 275, sv: 'Palestinskt territorium, ockuperat', iso2: 'ps' },
  { code: 276, sv: 'Tyskland', iso2: 'de' },
  { code: 288, sv: 'Ghana', iso2: 'gh' },
  { code: 292, sv: 'Gibraltar', iso2: 'gi' },
  { code: 296, sv: 'Kiribati', iso2: 'ki' },
  { code: 300, sv: 'Grekland', iso2: 'gr' },
  { code: 304, sv: 'Grönland', iso2: 'gl' },
  { code: 308, sv: 'Grenada', iso2: 'gd' },
  { code: 312, sv: 'Guadeloupe', iso2: 'gp' },
  { code: 316, sv: 'Guam', iso2: 'gu' },
  { code: 320, sv: 'Guatemala', iso2: 'gt' },
  { code: 324, sv: 'Guinea', iso2: 'gn' },
  { code: 328, sv: 'Guyana', iso2: 'gy' },
  { code: 332, sv: 'Haiti', iso2: 'ht' },
  { code: 334, sv: 'Heard- och McDonaldsöarna', iso2: 'hm' },
  { code: 336, sv: 'Vatikanstaten', iso2: 'va' },
  { code: 340, sv: 'Honduras', iso2: 'hn' },
  { code: 344, sv: 'Hongkong', iso2: 'hk' },
  { code: 348, sv: 'Ungern', iso2: 'hu' },
  { code: 352, sv: 'Island', iso2: 'is' },
  { code: 356, sv: 'Indien', iso2: 'in' },
  { code: 360, sv: 'Indonesien', iso2: 'id' },
  { code: 364, sv: 'Iran', iso2: 'ir' },
  { code: 368, sv: 'Irak', iso2: 'iq' },
  { code: 372, sv: 'Irland', iso2: 'ie' },
  { code: 376, sv: 'Israel', iso2: 'il' },
  { code: 380, sv: 'Italien', iso2: 'it' },
  { code: 384, sv: 'Elfenbenskusten', iso2: 'ci' },
  { code: 388, sv: 'Jamaica', iso2: 'jm' },
  { code: 392, sv: 'Japan', iso2: 'jp' },
  { code: 398, sv: 'Kazakstan', iso2: 'kz' },
  { code: 400, sv: 'Jordanien', iso2: 'jo' },
  { code: 404, sv: 'Kenya', iso2: 'ke' },
  { code: 408, sv: 'Nordkorea', iso2: 'kp' },
  { code: 410, sv: 'Sydkorea', iso2: 'kr' },
  { code: 414, sv: 'Kuwait', iso2: 'kw' },
  { code: 417, sv: 'Kirgizistan', iso2: 'kg' },
  { code: 418, sv: 'Laos', iso2: 'la' },
  { code: 422, sv: 'Libanon', iso2: 'lb' },
  { code: 426, sv: 'Lesotho', iso2: 'ls' },
  { code: 428, sv: 'Lettland', iso2: 'lv' },
  { code: 430, sv: 'Liberia', iso2: 'lr' },
  { code: 434, sv: 'Libyen', iso2: 'ly' },
  { code: 438, sv: 'Liechtenstein', iso2: 'li' },
  { code: 440, sv: 'Litauen', iso2: 'lt' },
  { code: 442, sv: 'Luxemburg', iso2: 'lu' },
  { code: 446, sv: 'Macau', iso2: 'mo' },
  { code: 450, sv: 'Madagaskar', iso2: 'mg' },
  { code: 454, sv: 'Malawi', iso2: 'mw' },
  { code: 458, sv: 'Malaysia', iso2: 'my' },
  { code: 462, sv: 'Maldiverna', iso2: 'mv' },
  { code: 466, sv: 'Mali', iso2: 'ml' },
  { code: 470, sv: 'Malta', iso2: 'mt' },
  { code: 474, sv: 'Martinique', iso2: 'mq' },
  { code: 478, sv: 'Mauretanien', iso2: 'mr' },
  { code: 480, sv: 'Mauritius', iso2: 'mu' },
  { code: 484, sv: 'Mexiko', iso2: 'mx' },
  { code: 492, sv: 'Monaco', iso2: 'mc' },
  { code: 496, sv: 'Mongoliet', iso2: 'mn' },
  { code: 498, sv: 'Moldavien', iso2: 'md' },
  { code: 499, sv: 'Montenegro', iso2: 'me' },
  { code: 500, sv: 'Montserrat', iso2: 'ms' },
  { code: 504, sv: 'Marocko', iso2: 'ma' },
  { code: 508, sv: 'Moçambique', iso2: 'mz' },
  { code: 512, sv: 'Oman', iso2: 'om' },
  { code: 516, sv: 'Namibia', iso2: 'na' },
  { code: 520, sv: 'Nauru', iso2: 'nr' },
  { code: 524, sv: 'Nepal', iso2: 'np' },
  { code: 528, sv: 'Nederländerna', iso2: 'nl' },
  { code: 531, sv: 'Curaçao', iso2: 'cw' },
  { code: 533, sv: 'Aruba', iso2: 'aw' },
  { code: 534, sv: 'Sint Maarten (Holländska delen)', iso2: 'sx' },
  { code: 535, sv: 'Karibiska Nederländerna', iso2: 'bq' },
  { code: 540, sv: 'Nya Kaledonien', iso2: 'nc' },
  { code: 548, sv: 'Vanuatu', iso2: 'vu' },
  { code: 554, sv: 'Nya Zeeland', iso2: 'nz' },
  { code: 558, sv: 'Nicaragua', iso2: 'ni' },
  { code: 562, sv: 'Niger', iso2: 'ne' },
  { code: 566, sv: 'Nigeria', iso2: 'ng' },
  { code: 570, sv: 'Niue', iso2: 'nu' },
  { code: 574, sv: 'Norfolkön', iso2: 'nf' },
  { code: 578, sv: 'Norge', iso2: 'no' },
  { code: 580, sv: 'Nordmarianerna', iso2: 'mp' },
  { code: 581, sv: 'USA:s yttre öar', iso2: 'um' },
  { code: 583, sv: 'Mikronesiska federationen', iso2: 'fm' },
  { code: 584, sv: 'Marshallöarna', iso2: 'mh' },
  { code: 585, sv: 'Palau', iso2: 'pw' },
  { code: 586, sv: 'Pakistan', iso2: 'pk' },
  { code: 591, sv: 'Panama', iso2: 'pa' },
  { code: 598, sv: 'Papua Nya Guinea', iso2: 'pg' },
  { code: 600, sv: 'Paraguay', iso2: 'py' },
  { code: 604, sv: 'Peru', iso2: 'pe' },
  { code: 608, sv: 'Filippinerna', iso2: 'ph' },
  { code: 612, sv: 'Pitcairnöarna', iso2: 'pn' },
  { code: 616, sv: 'Polen', iso2: 'pl' },
  { code: 620, sv: 'Portugal', iso2: 'pt' },
  { code: 624, sv: 'Guinea Bissau', iso2: 'gw' },
  { code: 626, sv: 'Östtimor', iso2: 'tl' },
  { code: 630, sv: 'Puerto Rico', iso2: 'pr' },
  { code: 634, sv: 'Qatar', iso2: 'qa' },
  { code: 638, sv: 'Réunion', iso2: 're' },
  { code: 642, sv: 'Rumänien', iso2: 'ro' },
  { code: 643, sv: 'Ryssland', iso2: 'ru' },
  { code: 646, sv: 'Rwanda', iso2: 'rw' },
  { code: 652, sv: 'Saint Barthélemy', iso2: 'bl' },
  { code: 654, sv: 'Sankta Helena', iso2: 'sh' },
  { code: 659, sv: 'Saint Kitts och Nevis', iso2: 'kn' },
  { code: 660, sv: 'Anguilla', iso2: 'ai' },
  { code: 662, sv: 'Saint Lucia', iso2: 'lc' },
  { code: 663, sv: 'Saint Martin, Frankrike', iso2: 'mf' },
  { code: 666, sv: 'Saint-Pierre och Miquelon', iso2: 'pm' },
  { code: 670, sv: 'Saint Vincent och Grenadinerna', iso2: 'vc' },
  { code: 674, sv: 'San Marino', iso2: 'sm' },
  { code: 678, sv: 'São Tomé och Príncipe', iso2: 'st' },
  { code: 682, sv: 'Saudiarabien', iso2: 'sa' },
  { code: 686, sv: 'Senegal', iso2: 'sn' },
  { code: 688, sv: 'Serbien', iso2: 'rs' },
  { code: 690, sv: 'Seychellerna', iso2: 'sc' },
  { code: 694, sv: 'Sierra Leone', iso2: 'sl' },
  { code: 702, sv: 'Singapore', iso2: 'sg' },
  { code: 703, sv: 'Slovakien', iso2: 'sk' },
  { code: 704, sv: 'Vietnam', iso2: 'vn' },
  { code: 705, sv: 'Slovenien', iso2: 'si' },
  { code: 706, sv: 'Somalia', iso2: 'so' },
  { code: 710, sv: 'Sydafrika', iso2: 'za' },
  { code: 716, sv: 'Zimbabwe', iso2: 'zw' },
  { code: 724, sv: 'Spanien', iso2: 'es' },
  { code: 732, sv: 'Västsahara', iso2: 'eh' },
  { code: 736, sv: 'Sudan', iso2: 'sd' },
  { code: 740, sv: 'Surinam', iso2: 'sr' },
  { code: 744, sv: 'Svalbard och Jan Mayen', iso2: 'sj' },
  { code: 748, sv: 'Swaziland', iso2: 'sz' },
  { code: 752, sv: 'Sverige', start: true, iso2: 'se' },
  { code: 756, sv: 'Schweiz', iso2: 'ch' },
  { code: 760, sv: 'Syrien', iso2: 'sy' },
  { code: 762, sv: 'Tadzjikistan', iso2: 'tj' },
  { code: 764, sv: 'Thailand', iso2: 'th' },
  { code: 768, sv: 'Togo', iso2: 'tg' },
  { code: 772, sv: 'Tokelauöarna', iso2: 'tk' },
  { code: 776, sv: 'Tonga', iso2: 'to' },
  { code: 780, sv: 'Trinidad och Tobago', iso2: 'tt' },
  { code: 784, sv: 'Förenade Arabemiraten', iso2: 'ae' },
  { code: 788, sv: 'Tunisien', iso2: 'tn' },
  { code: 792, sv: 'Turkiet', iso2: 'tr' },
  { code: 795, sv: 'Turkmenistan', iso2: 'tm' },
  { code: 796, sv: 'Turks- och Caicosöarna', iso2: 'tc' },
  { code: 798, sv: 'Tuvalu', iso2: 'tv' },
  { code: 800, sv: 'Uganda', iso2: 'ug' },
  { code: 804, sv: 'Ukraina', iso2: 'ua' },
  { code: 807, sv: 'Nordmakedonien', iso2: 'mk' },
  { code: 818, sv: 'Egypten', iso2: 'eg' },
  { code: 826, sv: 'Storbritannien', iso2: 'gb' },
  { code: 831, sv: 'Guernsey', iso2: 'gg' },
  { code: 832, sv: 'Jersey', iso2: 'je' },
  { code: 833, sv: 'Isle of Man', iso2: 'im' },
  { code: 834, sv: 'Tanzania', iso2: 'tz' },
  { code: 840, sv: 'USA', iso2: 'us' },
  { code: 850, sv: 'Amerikanska Jungfruöarna', iso2: 'vi' },
  { code: 854, sv: 'Burkina Faso', iso2: 'bf' },
  { code: 858, sv: 'Uruguay', iso2: 'uy' },
  { code: 860, sv: 'Uzbekistan', iso2: 'uz' },
  { code: 862, sv: 'Venezuela', iso2: 've' },
  { code: 876, sv: 'Wallis- och Futunaöarna', iso2: 'wf' },
  { code: 882, sv: 'Samoa', iso2: 'ws' },
  { code: 887, sv: 'Jemen', iso2: 'ye' },
  { code: 894, sv: 'Zambia', iso2: 'zm' },
  // NON_EU	Ej EU Land som inte finns med i Europeiska Unionen
];

export default countries;
